import React from 'react';

import Icon from '@projeccions-pdc/react-icon';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { Viewer, Worker, SpecialZoomLevel, Button, Position, Tooltip } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import PDFLocales from './PDFViewerLocale';

const TOOLTIP_OFFSET = { left: 0, top: 8 };
const supportedLocales = ['en', 'es', 'de', 'fr'];
const NewPDFViewer = ({ url, shareable, sharebutton, onClose, onPresentationModeChange, language, isShare }) => {
    const smartphone = useMediaQuery('(max-width: 800px)');
    const pdfLocale = supportedLocales.indexOf(language) !== -1 ? PDFLocales[language] : PDFLocales['en'];
    // const renderToolbar = (Toolbar) => (
    //     <>
    //         <Toolbar />
    //         <div
    //             style={{
    //                 borderTop: '1px solid rgba(0, 0, 0, 0.1)',
    //                 marginTop: '4px',
    //                 padding: '4px',
    //             }}
    //         >
    //             Custom element
    //         </div>
    //     </>
    // );
    // const fullScreenPluginInstance = fullScreenPlugin();
    // const { EnterFullScreen } = fullScreenPluginInstance;
    const renderToolbar = (Toolbar) => (
        <Toolbar>
            {(slots) => {
                const {
                    CurrentPageInput,
                    Download,
                    EnterFullScreen,
                    GoToNextPage,
                    GoToPreviousPage,
                    NumberOfPages,
                    Print,
                    ShowSearchPopover,
                    Zoom,
                    ZoomIn,
                    ZoomOut,
                } = slots;

                return (
                    <div
                        style={{
                            alignItems: 'center',
                            display: 'flex',
                        }}
                    >
                        <div style={{ padding: '0px 2px' }}>
                            <ShowSearchPopover />
                        </div>
                        {!smartphone && (
                            <div style={{ padding: '0px 2px' }}>
                                <ZoomOut />
                            </div>
                        )}
                        <div style={{ padding: '0px 2px' }}>
                            <Zoom />
                        </div>
                        {!smartphone && (
                            <div style={{ padding: '0px 2px' }}>
                                <ZoomIn />
                            </div>
                        )}
                        {!smartphone && (
                            <>
                                <div style={{ padding: '0px 2px', marginLeft: 'auto' }}>
                                    <GoToPreviousPage />
                                </div>
                                <div style={{ padding: '0px 2px' }}>
                                    <CurrentPageInput /> / <NumberOfPages />
                                </div>
                                <div style={{ padding: '0px 2px' }}>
                                    <GoToNextPage />
                                </div>
                            </>
                        )}
                        {!smartphone && (
                            <div style={{ padding: '0px 2px', marginLeft: 'auto' }}>
                                {/* <EnterFullScreen /> */}
                                <EnterFullScreen>
                                    {(props) => (
                                        <Tooltip
                                            position={Position.BottomCenter}
                                            target={
                                                <Button onClick={props.onClick}>
                                                    <Icon name="md-fullscreen" size={20} />
                                                </Button>
                                            }
                                            content={() => pdfLocale.fullScreen.enterFullScreen}
                                            offset={TOOLTIP_OFFSET}
                                        />
                                    )}
                                </EnterFullScreen>
                            </div>
                        )}

                        {(shareable || isShare) && (
                            <>
                                <div style={{ padding: '0px 2px' }}>
                                    <Download>
                                        {(props) => (
                                            <Tooltip
                                                position={Position.BottomCenter}
                                                target={
                                                    <Button onClick={props.onClick}>
                                                        <Icon name="md-file-download" size={20} />
                                                    </Button>
                                                }
                                                content={() => pdfLocale.download.download}
                                                offset={TOOLTIP_OFFSET}
                                            />
                                        )}
                                    </Download>
                                </div>
                                {!smartphone && (
                                    <div style={{ padding: '0px 2px' }}>
                                        <Print>
                                            {(props) => (
                                                <Tooltip
                                                    position={Position.BottomCenter}
                                                    target={
                                                        <Button onClick={props.onClick}>
                                                            <Icon name="md-print" size={20} />
                                                        </Button>
                                                    }
                                                    content={() => pdfLocale.print.print}
                                                    offset={TOOLTIP_OFFSET}
                                                />
                                            )}
                                        </Print>
                                    </div>
                                )}
                            </>
                        )}
                        {onPresentationModeChange !== undefined && (
                            <>
                                <div style={{ padding: '0px 2px', marginLeft: !smartphone ? '0' : 'auto' }}>|</div>
                                <div style={{ padding: '0px 2px' }}>
                                    <Tooltip
                                        position={Position.BottomCenter}
                                        target={
                                            <Button onClick={onPresentationModeChange}>
                                                <Icon name="md-slideshow" size={20} />
                                            </Button>
                                        }
                                        content={() => pdfLocale.slideShowMode}
                                        offset={TOOLTIP_OFFSET}
                                    />
                                </div>
                            </>
                        )}
                        {shareable && sharebutton && <div style={{ padding: '0px 2px' }}>{sharebutton}</div>}
                        <div style={{ padding: '0px 2px' }}>|</div>
                        <div style={{ padding: '0px 2px' }}>
                            <Tooltip
                                position={Position.BottomCenter}
                                target={
                                    <Button onClick={onClose}>
                                        <Icon name="md-close" size={20} />
                                    </Button>
                                }
                                content={() => pdfLocale.search.close}
                                offset={TOOLTIP_OFFSET}
                            />
                            {/* <button className="rpv-core-button" style={{ fontSize: 16 }} onClick={onClose}>
                                <Icon name="md-close" />
                            </button> */}
                        </div>
                    </div>
                );
            }}
        </Toolbar>
    );
    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        renderToolbar,
        sidebarTabs: (defaultTabs) => [
            // Remove the attachments tab (`defaultTabs[2]`)
            defaultTabs[0], // Thumbnails tab
            // defaultTabs[1], // Bookmarks tab
        ],
    });
    // const defaultLayoutPluginInstance = defaultLayoutPlugin();
    return (
        <Worker workerUrl="/pdf.worker.min.js">
            <Viewer
                fileUrl={url}
                plugins={[defaultLayoutPluginInstance]}
                defaultScale={SpecialZoomLevel.PageWidth}
                localization={pdfLocale}
            />
        </Worker>
    );
};

export default NewPDFViewer;
